import addToCart from '../lib/addToCart';
import { closePopup } from '../utils/popupController';
import renderMinicart from '../lib/renderMinicart';
import { SELECTORS } from '../utils/constants';
import updateCart from '../lib/updateCart';

const initAtcForm = (isPopup = false) => {
  const atcForms = document.querySelectorAll('[data-product-form]');
  if (!atcForms.length) return;

  const setBtnLoadingState = (button, spinner, loading) => {
    button.classList.toggle('pointer-events-none', loading);
    button.classList.toggle('opacity-50', loading);
    if (spinner) spinner.classList.toggle('hidden', !loading);
  };

  const getItem = (form) => {
    const variantId = +form.id.value;
    const quantity = +form.elements['quantity'].value;

    return [variantId, quantity];
  };

  const getAttributes = (form) => {
    const attributeInputs = form.querySelectorAll('input[name^="attributes["]');
    const attributes = {};

    attributeInputs.forEach((input) => {
      const match = input.name.match(/^attributes\[(.+)\]$/);
      if (match) {
        const key = match[1];
        attributes[key] = input.value;
      }
    });
    return attributes;
  };

  const addVariantToCart = async (evt) => {
    evt.preventDefault();
    const submitBtnSpinner = evt.submitter?.querySelector(SELECTORS.LOADING_SPINNER);
    setBtnLoadingState(evt.submitter, submitBtnSpinner, true);
    try {
      const [variantId, quantity] = getItem(evt.target);
      const attributes = getAttributes(evt.target);
      await addToCart(variantId, quantity);
      if (attributes) {
        await updateCart(attributes);
      }
      await renderMinicart();
      if (isPopup) closePopup();
      window.theme.minicart?.open();
    } catch (error) {
      console.error('Error adding variant to cart:', error);
    } finally {
      setBtnLoadingState(evt.submitter, submitBtnSpinner, false);
    }
  };

  atcForms.forEach(form => {
    form.addEventListener('submit', addVariantToCart);
  });
};

export default initAtcForm;
